module.exports = __webpack_public_path__ + "media/images/sp/stores/suns/icon_title_lemon-2307784a76fb5add12ffe0d66224ee1a.svg";